<template>
  <div class="family">
    <div class="head">
      <div class="box">
        <p>加入知春</p>
      </div>
    </div>
    <div class="content">
      <div v-for="(item, index) in list" :key="index" @click="showModal(item)">
        <div class="item">
          <h3>{{ item.title }}</h3>
          <p>{{ item.tip }}</p>
        </div>
      </div>
    </div>
    <ReModel />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { information } from "@/util/recruit";
export default {
  data() {
    return {
      list: information,
    };
  },
  methods: {
    ...mapMutations(["changeRModel", "setInfo"]),
    showModal(item) {
      this.changeRModel(true);
      this.setInfo(item);
    },
  },
  computed: {
    ...mapGetters({ language: "getType" }),
    title() {
      return this.language == "中文" ? "成员企业" : "Wandering ";
    },
  },
};
</script>

<style lang="less" scoped>
.family {
  position: relative;
  width: 100%;
  margin-top: 200px;
  .head {
    width: 100%;
    height: 315px;
    background: url("../assets/teambg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .box {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      h4 {
        margin-top: 0px;
        font-size: 44px;
        color: rgba(255, 255, 255, 1);
        font-weight: normal;
      }
      p {
        font-size: 42px;
        margin-top: 40px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .content {
    width: 1200px;
    margin: -200px auto 60px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 320px;
      height: 166px;
      margin-top: 64px;
      margin-right: 42px;

      h3 {
        font-size: 26px;
      }
      p {
        font-size: 18px;
      }
      &::nth-of-type(3n) {
        margin-right: 0;
      }
      background-color: rgba(255, 255, 255, 1);
      background-repeat: no-repeat;
      background-position: center center;
      box-shadow: 3px 4px 21px 0px rgba(70, 214, 177, 0.24);
      border-radius: 15px;
      position: relative;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recruit.vue